import React, { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import { Outlet } from "react-router-dom";
import "../App.css";

function AdminLayout() {
  const getIsDesktop = () =>
    typeof window !== "undefined" && window.innerWidth >= 992;
  const [isDesktop, setIsDesktop] = useState(getIsDesktop);
  const [isSidebarOpen, setIsSidebarOpen] = useState(getIsDesktop);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 992px)");
    const handleViewportChange = (event) => {
      setIsDesktop(event.matches);
      setIsSidebarOpen(event.matches);
    };

    handleViewportChange(mediaQuery);
    mediaQuery.addEventListener("change", handleViewportChange);

    return () => {
      mediaQuery.removeEventListener("change", handleViewportChange);
    };
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  useEffect(() => {
    if (isDesktop || !isSidebarOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isDesktop, isSidebarOpen]);

  const closeSidebarAfterNavigation = () => {
    if (!isDesktop) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className={`admin-layout admin-bg ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        onNavigate={closeSidebarAfterNavigation}
      />

      {!isDesktop && isSidebarOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation menu"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="admin-content">
        <Navbar
          isSidebarOpen={isSidebarOpen}
          onSidebarToggle={() => setIsSidebarOpen((isOpen) => !isOpen)}
        />

        <main className="admin-page-content p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
